import Vue from 'vue';

// Domain
import { AssociatedProductStateManager } from '../../domain/state/associated-product-state-manager';
import AssociatedProductState from '../../domain/state/associated-product-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class AssociatedProductVueStateManager
implements AssociatedProductStateManager {
  private _state: AssociatedProductState = Vue.observable<AssociatedProductState>(
    new AssociatedProductState(),
  );

  private readonly observers: Observer[] = [];

  get state(): AssociatedProductState {
    return this._state;
  }

  set state(value: AssociatedProductState) {
    this._state = value;
  }

  patch(state: Partial<AssociatedProductState>) {
    type Keys = keyof AssociatedProductState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll(): void {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer): void {
    this.observers.push(observer);
  }
}
